import { Group } from '@mantine/core';
import { IconCalendarEvent, IconFilter, IconMessageCircle } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans } from '@lingui/react';
import { closeAllModals, openContextModal } from '@mantine/modals';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { CustomModalHeader } from '../../../Molecules/Dialogs';
import { TaskListContext } from '../../../Service/Context/TaskListContext';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';
import NavAddIcon from './NavAddIcon';

interface HandlersProps {
  filter: () => void;
}

const TasksPageFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();
  const { profile, unreadMessagesProps } = useContext(ProfileContext);
  const { unreadCount } = unreadMessagesProps ?? { unreadCount: 0 };
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { refresh } = useContext(TaskListContext);

  const addTask = () =>
    executeWithLicenceCheck(LicenceS.Restrictions.SAVE_TASK, () => {
      openContextModal({
        modal: 'taskCreateModal',
        innerProps: {
          title: (
            <CustomModalHeader>
              <Trans id="task.create" />
            </CustomModalHeader>
          ),
          profile,
          entityType: 'events',
          finish: () => {
            closeAllModals();
            refresh();
          },
          showEntityTypeSelection: true,
          centered: true,
        },
      });
    });

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Filter" onClick={filter}>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <NavAddIcon onClick={addTask} />
      <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
        <InboxIconWithIndicator unreadCount={unreadCount} />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Support" onClick={openWidget}>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default TasksPageFooter;
